import styled from 'styled-components';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export const Title = styled(Typography)`
    color: #646468;
    font-size: 12px;
    font-weight: 700;
`;

export const Bar = styled(Box)`
    position: relative;
    height: 20px;
`;

export const RedBar = styled(Bar)`
    border-radius: 4px 0 0 4px;
`;
export const YellowBar = styled(Bar)``;
export const GreenBar = styled(Bar)`
    border-radius: 0 4px 4px 0;
`;

export const BarLabel = styled.span`
    position: absolute;
    bottom: -14px;
    left: 0;

    color: #697d90;
    font-size: 10px;
    line-height: 10px;
    font-weight: 500;
`;

export const IndicatorPointer = styled(Box)`
    position: absolute;
    bottom: 0;
    width: 2px;
    height: 24px;
    &::before {
        content: '';
        position: absolute;
        background-color: #ffffff;
        width: 2px;
        height: 20px;
        top: 4px;
        right: 2px;
    }
`;

export const IndicatorLabel = styled(Box)`
    background-color: inherit;
    position: absolute;
    right: -13px;
    bottom: 24px;
    font-size: 14px;
    line-height: 14px;
    font-weight: 700;
    letter-spacing: 0.07px;
    color: #fff;
    text-align: center;
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.12);
    display: inline-flex;
    padding: 4px 6px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
`;
